<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="400px"
  >
    <v-card>
      <v-card-title class="headline pa-3">
        <v-text-field
          v-model.trim="search"
          append-icon="mdi-magnify"
          label="Search stores"
          single-line
          clearable
          outlined
          hide-details
          dense
        />
      </v-card-title>
      <v-divider />
      <v-card-text class="px-0">
        <v-list class="py-0">
          <div
            v-for="store in filteredStores"
            :key="`stores--${store.id}`"
          >
            <v-list-item>
              <v-list-item-title>
                <span
                  class="action"
                  @click="goTo(store)"
                >
                  {{ store.name }}
                </span>
              </v-list-item-title>
              <v-list-item-action>
                <v-btn
                  v-if="unlink"
                  icon
                  color="error"
                  small
                  @click="unlinkPosServer(store)"
                >
                  <v-icon small>
                    mdi-close
                  </v-icon>
                </v-btn>

                <v-btn
                  v-else
                  icon
                  color="success"
                  small
                  @click="linkPosServers(store)"
                >
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider />
          </div>
          <div
            v-if="!filteredStores.length && search"
            class="py-3"
            align="center"
          >
            No records found. reset the search
          </div>
        </v-list>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          class="white--text"
          @click.native="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AssignPosServerToStore",
  data() {
    return {
      dialog: false,
      stores: [],
      search: "",
      posServerId: null,
      unlink: false
    };
  },
  computed: {
    filteredStores() {
      if (this.search) {
        const searchText = this.search.toUpperCase();
        return this.stores.filter((store) => {
          return store.name.toUpperCase().indexOf(searchText) > -1;
        });
      }
      return this.stores;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.posServerId = null;
      this.stores = [];
    },
    open(id) {
      this.posServerId = id;
      this.unlink = false;
      this.$http
        .get(`${this.ADMIN_API_URL}/getUnassignedStores`)
        .then(function (data) {
          this.stores = data.body;
          this.dialog = true;
        });
    },
    openAssignedStores(id, stores) {
      this.unlink = true;
      this.posServerId = id;
      this.stores = stores;
      this.dialog = true;
    },
    linkPosServers(store) {
      this.$root.$confirm
        .open("Confirm", `Are you sure you to add "${store.name}"?`, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.req = {
            storeId: store.id,
            posServerId: this.posServerId
          };
          this.$http
            .put(
              `${this.ADMIN_API_URL}/stores/${store.id}/linkPosServers`,
              this.req
            )
            .then(
              function (data) {
                this.handleSuccess(data.body);
              },
              function (failure) {
                this.handleFailure(failure);
              }
            );
        });
    },
    unlinkPosServer(store) {
      this.$root.$confirm
        .open("Confirm", `Are you sure you to unlink "${store.name}"?`, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/stores/${store.id}/unlinkPosServers`)
            .then(
              function (data) {
                this.handleSuccess(data.body);
              },
              function (failure) {
                this.handleFailure(failure);
              }
            );
        });
    },
    handleSuccess(response) {
      this.$emit("reload");
      this.close();
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
    },
    goTo(store) {
      this.$router.push({
        name: "storeInfo",
        params: {
          accountId: store.accountId,
          storeId: store.id
        }
      });
    }
  }
};
</script>

<style scoped>
.action {
  text-decoration: underline;
  cursor: pointer;
}
</style>